module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKBAMAAAB/HNKOAAAAAXNSR0IB2cksfwAAABtQTFRFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAlFHiIAAAAAl0Uk5TABB/gP/P0NLTzlg2jwAAAENJREFUeJxjEBJgYFRkMAlkEHVmEHMVDElkYEwpdxNgYJBwaWRgYBB3KWRgYAzpcBVgEHUTTAlkMElkEHNmEAbqMgQAAEoItKUZXkMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/mpd-library/assets/compose-files-exit.png
// module id = 787
// module chunks = 0